export const getDataUrl = (
  routeParams: { [key: string]: string },
  templateDataUrl: string
) => {
  let targetDataUrl = templateDataUrl.slice();

  for (let key in routeParams) {
    let value = routeParams[key];
    targetDataUrl = targetDataUrl.replace(`{${key}}`, value);
  }

  const fallbackCount = 100;
  let i = 0;
  const regexp = new RegExp(/{\w+}/);
  while (regexp.test(targetDataUrl) || i >= fallbackCount) {
    // replace all non initialized parameters
    targetDataUrl = targetDataUrl.replace(regexp, '');
    i++;
  }

  return targetDataUrl;
};
